import { Component, Inject, Input, Output, EventEmitter } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

@Component({
    template: `
    <h1 mat-dialog-title [innerHTML]="this.title">Statement</h1>
    <div mat-dialog-content [innerHTML]="this.html"> 
    </div>
    <div mat-dialog-actions text-center>
      <p><input type="checkbox" id="confirmCardcheckBox" value="a1"  onchange="document.querySelector('#Confirm').disabled=!this.checked; document.querySelector('#Confirm').focus()">  I have read and acknowledge the payment method fees associated with my selection</p>      
    </div>
    <div align="end">
      <button mat-button id="Confirm"(click)='doConfirm()'  tabindex="1" disabled>Confirm</button>
      <button mat-button (click)='doCancel()'  tabindex="2" cdkFocusInitial>Cancel</button>  
      </div>  
    `
  })
  export class CardDialogComponent {
    html: string;
    title: string;
    constructor(
      public dialogRef: MatDialogRef<CardDialogComponent >,
      @Inject(MAT_DIALOG_DATA) public data: any) { }
  
      @Output() confirm: EventEmitter<boolean>=new EventEmitter<boolean>();      
  
    doCancel(): void{
      this.dialogRef.close();
      this.confirm.emit(false);
    }
  
    doConfirm(): void {
      this.dialogRef.close();
      this.confirm.emit(true);
    }
}

  


// WEBPACK FOOTER //
// ./src/app/shared/components/dialog/card-dialog.component.ts